import { styled } from "@mui/material/styles";

// Components
import { TreeView } from "@mui/x-tree-view/TreeView";

const styledName = "CategoryList";

export const StyledTreeView = styled(TreeView, { name: styledName })({
  "&": {
    overflowY: "scroll",
    padding: 0,
    height: "100%",
    width: "100%",
    maxWidth: "412px",
    margin: "auto",
  },
});
